import { api } from '@/shared/api';

export const fetchPublicOffer = () => {
  return api.seo.getPage('miniapp-agreement').then(({ data }) => data);
};
